export default __webpack_public_path__ + "static/waves-8780a8314ba4bdc8f0dc27ed9333cc0b.jpg";